import { getParam, setParam } from './imports/utils.js';
import PhotosCarouselProducts from './photos-carousel-products.vue';

export default {
  components: {
    PhotosCarouselProducts
  },
  props: {
    categories: {
      type: Array,
      required: true,
      default: []
    },
    products: {
      type: Array,
      required: true,
      default: () => []
    },
    spares: {
      type: Array,
      required: true,
      default: () => []
    },
    sparesgrouped: {
      type: Array,
      required: true,
      default: () => []
    },
  },
  data() {
    return {
      activeCategory: this.categories[0].id,
    }
  },
  methods: {
    changeCategory: function (id) {
      this.activeCategory = id;
      setParam('category', id);
    }
  },
  created() {
    const getCategory = getParam('category');
    if (getCategory) {
      this.activeCategory = Number(getCategory);
    }
  },
}